import { createFileRoute } from "@tanstack/react-router";
import TermsOfService from "@/pages/TermsOfService";

export const Route = createFileRoute("/algemene-voorwaarden")({
  head: () => ({
    meta: [
      { title: "Algemene Voorwaarden – De Hussel App" },
      { name: "description", content: "Lees de algemene voorwaarden van De Hussel App voor tennisclubs." },
      { property: "og:title", content: "Algemene Voorwaarden – De Hussel App" },
      { property: "og:description", content: "Lees de algemene voorwaarden van De Hussel App voor tennisclubs." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/algemene-voorwaarden" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/algemene-voorwaarden" }],
  }),
  component: TermsOfService,
});
